<template>
  <HgTooltip :class="$style.tooltip">
    <h4 :class="$style.toolTipHeader">{{ $t('renovation.tooltip.title') }}</h4>
    <p :class="$style.toolTipContent">{{ $t('renovation.tooltip.text') }}</p>
  </HgTooltip>
</template>
<script setup lang="ts">
import { HgTooltip } from '@smg-real-estate/domus';
</script>

<style lang="scss" module>
@use '@/assets/variables' as *;

.tooltip {
  [class*='HgTooltip_closeButton'] {
    [class*='HgIcon_icon'] {
      width: $space-100;
      height: $space-100;
    }
  }
  @include color-icon($color-black);
}

.toolTipHeader {
  @include vertical-margin(0, $space-75);
  @include heading-4;
}

.toolTipContent {
  @include vertical-margin;
  @include body-2;
}
</style>
